import router from '@/router'
import { AppHeader } from '@/components'

export default () => {
  router.addRoute({
    name: 'application-layout', // Do not remove this name, it's used in AppHeader
    path: '/opportunity/:opportunityId/application/:applicationId',
    components: {
      default: () => import('./application-layout.vue'),
      header: AppHeader
    },
    children: [
      {
        path: ':section?',
        name: 'application-form',
        components: {
          default: () => import('./application-form.vue')
        },
        meta: {
          permissions: {
            roles: ['user'],
            redirectTo: {
              name: 'login'
            }
          }
        }
      }
    ]
  })
}
